export default {
    data() {
        return {}
    },
    methods: {},
}


// WEBPACK FOOTER //
// ./src/mixins/footer.js